"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { useCallback } from "react";
import { PayLaterMtfGrid } from "./PayLaterMtfGrid";
import { PayLaterMtfStockItem } from "./PayLatermtfTypes";
import {
  PAY_LATER_MTF_CLICK_TYPE_CARD,
  PAY_LATER_MTF_CLICK_TYPE_LINK,
} from "./payLaterMtfTrackingConstants";
import { trackPayLaterMtfClick } from "./payLaterMtfTracking";

interface PayLaterMtfClientProps {
  stocks: PayLaterMtfStockItem[];
  defaultImage: string;
  errorMessage?: string;
  stockNotFoundImgUrl: string;
  href?: string;
  openInNewTab?: boolean | string;
  label?: string;
  modalTitle?: string;
  modalBtnCta?: string;
  successMsg?: string;
  errorMsg?: string;
  payOnly?: string;
  sectionTitle: string;
  componentPosition?: string;
}

export const PayLaterMtfClient = ({
  stocks,
  defaultImage,
  errorMessage,
  stockNotFoundImgUrl,
  href,
  openInNewTab,
  label,
  modalBtnCta,
  modalTitle,
  successMsg,
  errorMsg,
  payOnly,
  sectionTitle,
  componentPosition,
}: PayLaterMtfClientProps) => {
  const handleCardClick = useCallback(
    (stock: PayLaterMtfStockItem) => {
      void trackPayLaterMtfClick({
        clickType: PAY_LATER_MTF_CLICK_TYPE_CARD,
        sectionTitle,
        ctaText: stock.symbol,
        componentPosition,
        destinationUrl: stock.redirectURL ? `/${stock.redirectURL}` : undefined,
      });
    },
    [componentPosition, sectionTitle],
  );

  const handleViewAllClick = useCallback(() => {
    void trackPayLaterMtfClick({
      clickType: PAY_LATER_MTF_CLICK_TYPE_LINK,
      sectionTitle,
      ctaText: label ?? "View all",
      componentPosition,
      destinationUrl: href,
    });
  }, [componentPosition, href, label, sectionTitle]);

  return (
    <>
      <PayLaterMtfGrid
        stocks={stocks}
        defaultImage={defaultImage}
        errorMessage={errorMessage}
        stockNotFoundImgUrl={stockNotFoundImgUrl}
        modalTitle={modalTitle}
        modalBtnCta={modalBtnCta}
        successMsg={successMsg}
        errorMsg={errorMsg}
        payOnly={payOnly}
        nextArrowClassName="!right-0"
        onCardClick={handleCardClick}
      />

      <BFLLink openInNewTab={openInNewTab} href={href}>
        <div className="mt-[8px] max-w-fit cursor-pointer border-0 bg-transparent px-0 pb-[4px] pt-[8px] text-left transition-opacity duration-200 ease-linear">
          <button
            type="button"
            onClick={handleViewAllClick}
            className="text-link-primary h-[18px] cursor-pointer text-[14px] font-[500] md:text-[16px]"
          >
            {label}
          </button>
        </div>
      </BFLLink>
    </>
  );
};
